import DataObject from '../../../common/model/DataObject';

import Parameters from './Parameters';
import TableauPageList from './TableauPageList';

export default class Counterparty extends DataObject {
  getPropertyNames() {
    return [
      'guid',
      'code',
      'shortName',
      'displayName',
      'counterpartyViewerRole',
      'counterpartyEditorRole',
      'templateName',
      'showZeroValues',
      'heavyLightHourScheme',
      'firstDayOfWeek',
      'quickEntryConfiguration',
      'quickEntryLabels',
      'highlightHlhLlhFields',
      'isActive',
      'prescheduleDateRolloverPeriod',
      'prescheduleDateRolloverWarning',
      'realtimeDateRolloverPeriod',
      'realtimeDateRolloverWarning',
      'tableauSectionTitle',
      'tableauIsVisible',
      'tableauIsEnabled',
      'tableauScriptUrl',
      'tableauTokenGuid',
      'tableauPages',
      'parameters'
    ];
  }

  getDefaultOverrides() {
    return {
      guid: () => crypto.randomUUID()
    };
  }

  getChildClassTypes() {
    return {
      tableauPages: TableauPageList,
      parameters: Parameters
    };
  }

  getProjectedPropertyNames() {
    return [
      'guid',
      'code',
      'templateName'
    ];
  }

  getMappedProjectedPropertyValues() {
    return {
      parameters: {
        classType: Counterparty,
        propertyName: 'templateName',
        mode: 'match-schema',
        nestedPath: [
          'parameters',
          'counterpartyParameterSchema'
        ]
      }
    };
  }
}